// @flow
import evolve from 'ramda/es/evolve';

type Action = {
  type: string,
  payload: any,
  id?: string,
}

export type DefaultState = {
  content: Object,
  loading: boolean;
  occur: Object,
  error: Object,
}

export default function reducer<State: DefaultState>(defaultState: State) {
  return (state: State, { type, payload, id }: Action) => {
    if (type === 'requests') {
      return { ...state, loading: true };
    }

    if (type === 'failure') {
      return { ...state, error: payload, loading: false };
    }

    if (type === 'update') {
      return evolve({ content: payload }, state);
    }

    if (type === 'success') {
      return {
        ...defaultState,
        content: { ...defaultState.content, ...payload },
        loading: false,
      };
    }

    if (type === 'requests_id') {
      return {
        ...state,
        occur: {
          ...state.occur,
          ...(id ? { [id]: true } : {}),
        },
      };
    }

    if (type === 'success_id') {
      return {
        ...defaultState,
        loading: false,
        content: { ...defaultState.content, ...payload },
        occur: {
          ...state.occur,
          ...(id ? { [id]: false } : {}),
        },
      };
    }

    if (type === 'failure_id') {
      return {
        ...state,
        occur: {
          ...state.occur,
          ...(id ? { [id]: false } : {}),
        },
        errorById: {
          ...(id ? { [id]: payload } : {}),
        },
      };
    }

    const error = new Error('** Ошибка приложения, редюсер API **');
    return { ...state, error };
  };
}
